/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import PropTypes from "prop-types";
import { Box } from "@mui/material";
import MainCard from "components/MainCard";

const WelcomeCard = ({ children, ...other }) => (
    <MainCard
        sx={{
            // maxWidth: { xs: 960, lg: 1024 },
            margin: { xs: 2.5, md: 3 },
            "& > *": {
                flexGrow: 1,
                flexBasis: "50%",
            },
        }}
        content={false}
        {...other}
        border={false}
        boxShadow
        shadow={(theme) => theme.customShadows.z1}
    >
        <Box sx={{ p: { xs: 2, sm: 3, md: 4, xl: 5 } }}>{children}</Box>
    </MainCard>
);

WelcomeCard.propTypes = {
    children: PropTypes.node,
};

export default WelcomeCard;
